import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { LgvFormUtilityService } from '../../../core/services/lgv-form-utility.service';

@Component({
    selector: 'lgv-e-consent-dialog',
    templateUrl: './e-consent-dialog.component.html',
    styleUrls: ['./e-consent-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EConsentDialogComponent implements OnInit {
    econsentForm: UntypedFormGroup;
    isAgent = false;
    isClient = false;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<EConsentDialogComponent>,
        public dialog: MatDialog,
        private fb: FormBuilder,
        private lgvformUtilitySvc: LgvFormUtilityService) {
            this.isAgent =  data?.isAgent
            this.isClient =  !data?.isAgent
        }

    ngOnInit(): void {
        this.econsentForm = this.fb.group({
            consentToDoBusiness: [!!this.data?.businessConsentValue, [Validators.requiredTrue]],
            consentToReceiveMessages: [!!this.data?.consentToMessagesValue, []],
            consentDate: [null, this.isClient ? [] :[Validators.required]]
        });
    }

    openLoanApp() {
        this.dialogRef.close({
            consentToDoBusiness: true,
            consentToReceiveMessages: this.econsentForm.get('consentToReceiveMessages')?.value,
            date: this.isAgent ? this.econsentForm.get('consentDate')?.value.toISOString() : null
        });
    }

    openViewTermsModal(key: string) {
        let confirmationText = '';
        switch(key) {
            case 'consentToBusiness':
                confirmationText = `<h2>Your Consent To Do Business Electronically (the eDisclosure Agreement)</h2>
                <p>To use electronic signatures and receive documents electronically in connection with your use of this platform, you must read and consent to the terms outlined in this document, which require your ability to access and retain electronic documents.</p>
                <p>This electronic consent, if you provide it, applies to your use of this platform on any access device, including a desktop, laptop, tablet, mobile, or other electronic device, and to any document, including loan documents, disclosures, records, payoff demands, and mortgage statements (“Loan Documents”), that we provide to you in electronic form. If you provide electronic consent, we will be able to provide Loan Documents to you within this platform, in other portals, and/or through other methods we may use for delivery of Loan Documents. With Your consent, You will also be able to sign and authorize these Loan Documents electronically, rather than on paper.</p>`;
                break;
            case 'consentToMessages':
                confirmationText = `<h2>Your consent to receive messages from my lender for status updates on my loan</h2>
                <p>By checking the \"I consent to receive messages from my lender for Status updates on my loan\" checkbox, I\/we grant consent to receive messages from my lender for status updates on my loan.<\/p><p>SMS message service subscribers can: opt in to the SMS service in the Real-Finity Mortgage 1003 Web Application: opt out of the SMS service by replying with the keyword \"STOP\" to the message received; receive assistance with the SMS service by replying with the keyword \"HELP\" to the message received. You may receive up to five SMS messages per week, occasionally more. Standard message and data rates may apply.<\/p>`;
                break;
        }
        const viewTermsModal = this.dialog.open(ConfirmationDialogComponent, 
            {
                data: {
                    Confirmation: confirmationText,
                    woCancelButton: true
                },
                width: '450px'
            }
        )
    }

}
